var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharedNavigation',{scopedSlots:_vm._u([{key:"icon-items",fn:function(){return [_c('HeaderSearch',{on:{"search":_vm.search}}),_c('BasketNavItem',{}),_c('FavouriteNavItem')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }